import { useState } from 'react';
import ReviewAssessment from '../ReviewAssessment';
import SearchQuestions from '../SearchQuestions';

export default function CurrentAssessment() {
  const [questionBankDisplayFlag, setQuestionBankDisplayFlag] =
    useState<boolean>(false);
  return questionBankDisplayFlag === false ? (
    <ReviewAssessment setQuestionBankDisplayFlag={setQuestionBankDisplayFlag} />
  ) : (
    <SearchQuestions setQuestionBankDisplayFlag={setQuestionBankDisplayFlag} />
  );
}
